import { diffChars } from "diff";

const MAX_SUBTITLE_LENGTH = 45;
const MAX_ENGLISH_SUBTITLE_LENGTH = 65;
export function removeEmoji(text: string) {
  // 修复正则表达式，确保所有Unicode范围都是有效的
  var emojiRegex = new RegExp(
    [
      // 基本 Emoji 范围 (按正确的顺序排列)
      "(\ud83d[\udc00-\ude4f])", // 常见表情、手势、符号
      "(\ud83d[\ude80-\udeff])", // 交通、地图符号
      "(\ud83c[\udf00-\udfff])", // 自然、活动、食物
      "(\ud83e[\udd00-\uddff])", // 新增 Emoji（如笑脸、动物）
      "(\ud83e[\udc00-\udc7f])", // 更多新增
      "(\ud83c[\udde6-\uddff])", // 国旗
      "(\u2700-\u27bf)", // Dingbats（如 ✂ ✈ ✉）
      "(\u2600-\u26ff)", // 天气、星座等
      "(\u25a0-\u25ff)", // 几何图形
      "(\u23cf|\u23e9|\u23ed|\u23f0|\u23f1|\u23f2|\u23f3)", // 控制符号
      "(\u24c2|\u25b6|\u25c0)", // 按钮、符号
      "(\u3030|\u303d|\u3297|\u3299)", // 日文符号
      "(\u203c|\u2049|\u2139|\u2194-\u2199|\u21a9-\u21aa)", // 双感叹号、方向箭头等
      "(\u231a-\u231b)", // 手表、手机
      "(\ufe0f)", // 变体选择器（常与 Emoji 连用）
    ].join("|"),
    "g"
  );
  let result = text.replace(emojiRegex, "");
  return result;
}

function removeUnpairedQuotesAtEdges(text: string): string {
  // 先去掉首尾空格
  let result = text.trim();

  // 定义引号配对映射
  const quotePairs: { [key: string]: string } = {
    "\u2018": "\u2019", // 左单引号 -> 右单引号
    "\u2019": "\u2018", // 右单引号 -> 左单引号
    "\u201c": "\u201d", // 左双引号 -> 右双引号
    "\u201d": "\u201c", // 右双引号 -> 左双引号
    "'": "'", // 撇号 -> 撇号（自配对）
    '"': '"', // 引号 -> 引号（自配对）
  };

  const allQuotes = Object.keys(quotePairs);

  // 检查首部是否有不配对的引号
  let startIndex = 0;
  while (startIndex < result.length && allQuotes.includes(result[startIndex])) {
    const startQuote = result[startIndex];
    const expectedEndQuote = quotePairs[startQuote];

    // 检查是否在文本中找到配对的引号
    const endQuoteIndex = result.indexOf(expectedEndQuote, startIndex + 1);
    if (endQuoteIndex === -1) {
      // 没有找到配对的引号，移除这个引号
      startIndex++;
    } else {
      // 找到了配对的引号，保留这个引号
      break;
    }
  }

  // 检查末尾是否有不配对的引号
  let endIndex = result.length;
  while (endIndex > startIndex && allQuotes.includes(result[endIndex - 1])) {
    const endQuote = result[endIndex - 1];
    const expectedStartQuote = quotePairs[endQuote];

    // 检查是否在文本中找到配对的引号
    const startQuoteIndex = result.lastIndexOf(
      expectedStartQuote,
      endIndex - 2
    );
    if (startQuoteIndex === -1) {
      // 没有找到配对的引号，移除这个引号
      endIndex--;
    } else {
      // 找到了配对的引号，保留这个引号
      break;
    }
  }

  // 如果首部或末尾有引号被移除，返回处理后的文本
  if (startIndex > 0 || endIndex < result.length) {
    result = result.substring(startIndex, endIndex);
  }
  return result;

  // 处理句子中间的不配对引号 - 改进算法
  // 先找出所有引号的位置
  // const quotePositions: { index: number; char: string }[] = [];
  // for (let i = 0; i < result.length; i++) {
  //   if (allQuotes.includes(result[i])) {
  //     quotePositions.push({ index: i, char: result[i] });
  //   }
  // }

  // // 标记哪些引号是配对的
  // const pairedQuotes = new Set<number>();
  // for (let i = 0; i < quotePositions.length; i++) {
  //   if (pairedQuotes.has(quotePositions[i].index)) continue;

  //   const pos = quotePositions[i].index;
  //   const char = quotePositions[i].char;
  //   const expectedQuote = quotePairs[char];

  //   // 在后续位置寻找配对引号
  //   for (let j = i + 1; j < quotePositions.length; j++) {
  //     if (pairedQuotes.has(quotePositions[j].index)) continue;

  //     if (quotePositions[j].char === expectedQuote) {
  //       // 找到配对，标记这两个引号
  //       pairedQuotes.add(pos);
  //       pairedQuotes.add(quotePositions[j].index);
  //       break;
  //     }
  //   }
  // }

  // 构建结果字符串，只替换未配对的引号为空格
  // let finalResult = "";
  // for (let i = 0; i < result.length; i++) {
  //   const char = result[i];
  //   if (allQuotes.includes(char) ) { //&& !pairedQuotes.has(i)
  //     // 不配对的引号替换为空格
  //     finalResult += " ";
  //   } else {
  //     finalResult += char;
  //   }
  // }

  // return finalResult;
}

function removeLeadingPunctuation(text: string): string {
  // 先去掉首尾空格
  let result = text.trim();

  // 定义需要移除的首部标点符号
  const leadingPunctuation = [
    ",",
    "。",
    "，",
    ":",
    "：",
    ")",
    "）",
    "】",
    "]",
    "}",
  ];

  // 检查首部是否有需要移除的标点符号
  while (result.length > 0 && leadingPunctuation.includes(result[0])) {
    result = result.substring(1);
  }

  return result;
}

export function filterPunctuation(text: string) {
  // 1. 移除表情符号（Emoji）
  let result = removeEmoji(text);

  // 2. 检查并移除首部和末尾的不配对引号
  result = removeUnpairedQuotesAtEdges(result);

  // 3. 移除首部的逗号、句号或冒号
  result = removeLeadingPunctuation(result);

  // // 4. 保留英文字母间的单引号，其他不匹配的引号用空格替换
  // result = preserveApostrophesInEnglish(result);

  // 5. 清理多余空格
  result = result.replace(/\s+/g, " ").trim();

  return result;
}

export function splitLongText(text: string): string[] {
  var result: string[] = [];
  var buffer = "";
  var i = 0;
  var len = text.length;
  var inEnglishQuote = false; // 是否在英文引号内
  var parenDepth = 0; // 括号嵌套深度

  while (i < len) {
    var char = text.charAt(i);
    var nextChar = i + 1 < len ? text.charAt(i + 1) : "";
    var prevChar = i > 0 ? text.charAt(i - 1) : "";

    buffer += char;

    // 处理引号：进入或退出英文引号
    if (char === '"') {
      inEnglishQuote = !inEnglishQuote;
    }

    // 处理括号
    if (char === "(" || char === "（") {
      parenDepth++;
    } else if (char === ")" || char === "）") {
      parenDepth--;
      parenDepth = parenDepth < 0 ? 0 : parenDepth;
    }

    // 判断是否为句子结束符（中英文句号、感叹号、问号）
    var isEndOfSentence = false;

    // 中文句号、感叹号、问号
    if (char === "。" || char === "！" || char === "？") {
      isEndOfSentence = true;
    }
    // 英文句号、感叹号、问号，但要避免在缩写（如 3.14）或引号内错误拆分
    else if (
      (char === "." || char === "!" || char === "?") &&
      !inEnglishQuote &&
      parenDepth === 0
    ) {
      // 检查是否是数字中的小数点（如 37.57）
      if (char === ".") {
        var isDecimal =
          prevChar >= "0" &&
          prevChar <= "9" &&
          nextChar >= "0" &&
          nextChar <= "9";
        if (isDecimal) {
          isEndOfSentence = false;
        } else {
          isEndOfSentence = true;
        }
      } else {
        isEndOfSentence = true;
      }
    }

    // 如果是句子结束，且不在引号或括号中，则拆分
    if (isEndOfSentence && !inEnglishQuote && parenDepth === 0) {
      result.push(buffer.trim());
      buffer = "";
    }

    i++;
  }

  // 处理最后剩余内容
  if (buffer.trim() !== "") {
    result.push(buffer.trim());
  }

  return result;
}

// ==================== 字幕分段相关类型定义 ====================

/**
 * TTS返回的单词时间信息
 */
export interface WordTiming {
  word: string;
  start_time: number;
  end_time: number;
  unit_type: string;
}

/**
 * TTS返回的字幕时间信息
 */
export interface SubtitleTiming {
  words: WordTiming[];
}

/**
 * 字幕分段结果
 */
export interface SubtitleSegment {
  text: string;
  endTime: number;
}

// ==================== 字幕分段相关函数 ====================

/**
 * 根据文本内容找到对应的结束时间
 * @param text 文本内容
 * @param words TTS返回的单词时间信息数组
 * @returns 结束时间（秒）
 */
export function findEndTimeForText(text: string, words: WordTiming[]): number {
  // 移除空格，计算字符数量
  const textWithoutSpaces = text.replace(/\s/g, "");

  // 找到对应字符数量的word的结束时间
  let charCount = 0;
  for (let i = 0; i < words.length; i++) {
    charCount += words[i].word.length;
    if (charCount >= textWithoutSpaces.length) {
      // 支持驼峰命名 (endTime) 和下划线命名 (end_time)
      return (words[i] as any).endTime ?? words[i].end_time;
    }
  }

  // 如果没有找到，返回最后一个word的结束时间
  const lastWord = words[words.length - 1];
  return lastWord ? (lastWord as any).endTime ?? lastWord.end_time : 0;
}

/**
 * 创建字幕分段 - 使用累积位置计算时间
 * @param processedText 处理后的文本
 * @param words TTS返回的单词时间信息数组
 * @param maxLength 最大分段长度，默认40个字符
 * @returns 字幕分段数组
 */
export function createSubtitleSegmentsWithCumulativeTime1(
  processedText: string,
  words: WordTiming[],
  maxLength: number = MAX_SUBTITLE_LENGTH
): SubtitleSegment[] {
  const segments: SubtitleSegment[] = [];
  // 定义标点符号
  const punctuationMarks = /[。！？；，、]/g;
  // 定义单词边界（空格、标点）
  const wordBoundary = /[\s。！？；，、]/g;
  // 检测英文字符
  const isEnglishChar = /[a-zA-Z]/;

  let startIndex = 0;
  let cumulativeCharCount = 0; // 累积字符计数（不含空格）

  while (startIndex < processedText.length) {
    let endIndex = Math.min(startIndex + maxLength, processedText.length);

    if (endIndex < processedText.length) {
      let bestCutIndex = endIndex;

      // 检查当前段是否为中英文混合
      const currentSegment = processedText.slice(startIndex, endIndex + 1);
      const hasChinese = /[\u4e00-\u9fa5]/.test(currentSegment);
      const hasEnglish = isEnglishChar.test(currentSegment);

      if (hasChinese && hasEnglish) {
        // 中英文混合：尝试从第一个完整英文块前切分

        let englishStartIndex = -1;

        // 从 startIndex 开始，找第一个连续英文块的起始位置
        for (let i = startIndex; i < processedText.length; i++) {
          const char = processedText[i];

          // 找到第一个英文字符
          if (isEnglishChar.test(char)) {
            // 检查它是否是“单词开头”：前面是边界或开头
            if (i === startIndex || wordBoundary.test(processedText[i - 1])) {
              englishStartIndex = i;
              break;
            }
          }
        }

        // 如果找到了英文起始位置，且它在当前 maxLength 范围内
        if (englishStartIndex !== -1 && englishStartIndex > startIndex) {
          // 切在英文块之前（保留空格等边界）
          const cutPos =
            englishStartIndex - 1 >= startIndex
              ? englishStartIndex - 1
              : startIndex;

          if (cutPos - startIndex < maxLength) {
            bestCutIndex = cutPos;
          } else {
            // 英文太靠后，无法在 maxLength 内完成分割 → 回退
            bestCutIndex = fallbackToPunctuationOrBoundary(
              processedText,
              startIndex,
              endIndex,
              punctuationMarks,
              wordBoundary
            );
          }
        } else {
          // 未找到有效英文起点 → 回退
          bestCutIndex = fallbackToPunctuationOrBoundary(
            processedText,
            startIndex,
            endIndex,
            punctuationMarks,
            wordBoundary
          );
        }
      } else {
        // 非中英文混合：使用原逻辑
        bestCutIndex = fallbackToPunctuationOrBoundary(
          processedText,
          startIndex,
          endIndex,
          punctuationMarks,
          wordBoundary
        );
      }

      endIndex = bestCutIndex;
    }

    // 提取分段文本
    const segmentText = processedText.slice(startIndex, endIndex + 1);
    const segmentWithoutSpaces = segmentText.replace(/\s/g, "");

    // 更新累积字符数
    cumulativeCharCount += segmentWithoutSpaces.length;

    // 查找对应结束时间
    let segmentEndTime = 0;
    let charCount = 0;
    for (let i = 0; i < words.length; i++) {
      charCount += words[i].word.length;
      if (charCount >= cumulativeCharCount) {
        // 支持驼峰命名 (endTime) 和下划线命名 (end_time)
        segmentEndTime = (words[i] as any).endTime ?? words[i].end_time;
        break;
      }
    }

    segments.push({
      text: segmentText,
      endTime: segmentEndTime,
    });

    startIndex = endIndex + 1;
  }

  return segments;
}

// 对一段文本按规则切分（支持超长切分）
function splitSegmentByRules(
  text: string,
  words: WordTiming[],
  cumulativeCharCount: number,
  punctuationMarks: RegExp,
  wordBoundary: RegExp
): SubtitleSegment[] {
  const segments: SubtitleSegment[] = [];
  let pos = 0;
  let currentCumulative = cumulativeCharCount;

  // 再次判断是否为纯英文段
  const hasChinese = /[\u4e00-\u9fa5]/.test(text);
  const hasEnglish = /[a-zA-Z]/.test(text);
  const isPureEnglish = !hasChinese && hasEnglish;
  const currentMaxLength = isPureEnglish
    ? MAX_ENGLISH_SUBTITLE_LENGTH
    : MAX_SUBTITLE_LENGTH;

  while (pos < text.length) {
    let end = Math.min(pos + currentMaxLength, text.length);
    let cutIndex = end;

    if (end < text.length) {
      let found = false;
      // 优先找标点
      for (let i = end; i >= pos; i--) {
        if (punctuationMarks.test(text[i])) {
          cutIndex = i;
          found = true;
          break;
        }
      }
      if (!found) {
        for (let i = end; i >= pos; i--) {
          if (wordBoundary.test(text[i])) {
            cutIndex = i;
            break;
          }
        }
      }
    }

    cutIndex = Math.max(pos, cutIndex); // 安全性检查
    const segmentText = text.slice(pos, cutIndex + 1);
    const cleanLength = segmentText.replace(/\s/g, "").length;
    currentCumulative += cleanLength;

    let endTime = 0;
    let charCount = 0;
    for (let i = 0; i < words.length; i++) {
      charCount += words[i].word.length;
      if (charCount >= currentCumulative) {
        // 支持驼峰命名 (endTime) 和下划线命名 (end_time)
        endTime = (words[i] as any).endTime ?? words[i].end_time;
        break;
      }
    }

    segments.push({
      text: segmentText,
      endTime,
    });

    pos = cutIndex + 1;
  }

  return segments;
}

/**
 * 判断一句话中是否没有中文
 * @param text 输入文本
 * @returns true 表示没有中文，false 表示包含中文
 */
export function hasNoChinese(text: string): boolean {
  const chineseRegex = /[\u4e00-\u9fa5]/;
  return !chineseRegex.test(text);
}

/**
 * 创建字幕分段 - 使用累积位置计算时间
 * 支持：
 *  - 纯英文：最大长度设为 65
 *  - 中英文混合：优先从英文前切分中文
 */
export function createSubtitleSegmentsWithCumulativeTime(
  processedText: string,
  words: WordTiming[]
): SubtitleSegment[] {
  const segments: SubtitleSegment[] = [];

  // 定义标点符号和边界
  const punctuationMarks = /[。！？；，、]/g;
  const wordBoundary = /[\s。！？；，、]/g;
  const isEnglishChar = /[a-zA-Z]/;

  let startIndex = 0;
  let cumulativeCharCount = 0;

  while (startIndex < processedText.length) {
    const remainingText = processedText.slice(startIndex);

    // 检查是否为纯英文（无中文，有英文字母）
    const hasChinese = /[\u4e00-\u9fa5]/.test(remainingText);
    const hasEnglish = isEnglishChar.test(remainingText);
    const isPureEnglish = !hasChinese && hasEnglish;

    // 动态设置当前段的最大长度
    const currentMaxLength = isPureEnglish
      ? MAX_ENGLISH_SUBTITLE_LENGTH
      : MAX_SUBTITLE_LENGTH;

    // ===== 情况1：中英文混合，且英文出现在后面 =====
    if (hasChinese && hasEnglish) {
      let englishStartIndex = -1;
      for (let i = startIndex; i < processedText.length; i++) {
        if (isEnglishChar.test(processedText[i])) {
          if (i === startIndex || wordBoundary.test(processedText[i - 1])) {
            englishStartIndex = i;
            break;
          }
        }
      }

      if (englishStartIndex !== -1 && englishStartIndex > startIndex) {
        const chinesePartEnd = englishStartIndex - 1;
        const chinesePart = processedText.slice(startIndex, chinesePartEnd + 1);

        // 将中文部分按原 maxLength 切分（非纯英文）
        const chineseSegments = splitSegmentByRules(
          chinesePart,
          words,
          cumulativeCharCount,
          punctuationMarks,
          wordBoundary
        );

        segments.push(...chineseSegments);
        cumulativeCharCount += chinesePart.replace(/\s/g, "").length;
        startIndex = englishStartIndex;

        // 继续处理英文部分（下一轮会识别为纯英文 → 使用 65）
        continue;
      }
    }

    // ===== 情况2：非混合 或 无法特殊切分 → 按规则切分 =====
    let endIndex = Math.min(
      startIndex + currentMaxLength,
      processedText.length
    );
    let bestCutIndex = endIndex;

    if (endIndex < processedText.length) {
      let found = false;
      // 优先找标点
      for (let i = endIndex; i >= startIndex; i--) {
        if (punctuationMarks.test(processedText[i])) {
          bestCutIndex = i;
          found = true;
          break;
        }
      }
      if (!found) {
        for (let i = endIndex; i >= startIndex; i--) {
          if (wordBoundary.test(processedText[i])) {
            bestCutIndex = i;
            break;
          }
        }
      }
    }

    bestCutIndex = Math.max(startIndex, bestCutIndex); // 防止回退到起点前
    const segmentText = processedText.slice(startIndex, bestCutIndex + 1);
    const segmentWithoutSpaces = segmentText.replace(/\s/g, "");
    cumulativeCharCount += segmentWithoutSpaces.length;

    let segmentEndTime = 0;
    let charCount = 0;
    for (let i = 0; i < words.length; i++) {
      charCount += words[i].word.length;
      if (charCount >= cumulativeCharCount) {
        // 支持驼峰命名 (endTime) 和下划线命名 (end_time)
        segmentEndTime = (words[i] as any).endTime ?? words[i].end_time;
        break;
      }
    }

    segments.push({
      text: segmentText,
      endTime: segmentEndTime,
    });

    startIndex = bestCutIndex + 1;
  }

  return segments;
}

/**
 * 回退策略：优先找标点，再找单词边界
 */
function fallbackToPunctuationOrBoundary(
  text: string,
  startIndex: number,
  endIndex: number,
  punctuationMarks: RegExp,
  wordBoundary: RegExp
): number {
  let bestCutIndex = endIndex;

  // 优先找标点
  for (let i = endIndex; i >= startIndex; i--) {
    if (punctuationMarks.test(text[i])) {
      bestCutIndex = i;
      return bestCutIndex;
    }
  }

  // 再找单词边界
  for (let i = endIndex; i >= startIndex; i--) {
    if (wordBoundary.test(text[i])) {
      bestCutIndex = i;
      break;
    }
  }

  return bestCutIndex;
}

/**
 * 播放带分段字幕的音频
 * @param audio HTML音频元素
 * @param subtitleTiming TTS返回的字幕时间信息
 * @param originalText 原始文本
 * @param setDisplayMsg 设置显示字幕的函数
 * @param filterPunctuation 处理字幕的函数
 * @returns 清理函数
 */
export function playAudioWithSegmentedSubtitles(
  audio: HTMLAudioElement,
  originalText: string,
  subtitleTiming: SubtitleTiming,
  setDisplayMsg: (msg: string) => void
): (() => void) | undefined {
  const words = subtitleTiming.words;
  if (!words || words.length === 0) {
    // 如果没有时间信息，直接显示全部文本
    setDisplayMsg(filterPunctuation(originalText));
    return;
  }

  // 处理原始文本
  const processedText = filterPunctuation(originalText);

  // 将TTS返回的单词按顺序拼接成字符串
  const ttsText = words.map((word) => word.word).join("");

  // 使用diff库比较原始文本和TTS文本，找出公共部分
  const diffs = diffChars(processedText, ttsText);

  // 构建映射数组，记录TTS文本中每个字符在原始文本中的位置
  const ttsToOriginalMap: (number | null)[] = [];
  let originalIndex = 0;
  let ttsIndex = 0;

  diffs.forEach((part) => {
    if (part.added) {
      // TTS中新增的字符，在原始文本中找不到对应位置
      for (let i = 0; i < part.value.length; i++) {
        ttsToOriginalMap.push(null);
      }
      ttsIndex += part.value.length;
    } else if (part.removed) {
      // 原始文本中有的字符，TTS中没有，跳过
      originalIndex += part.value.length;
    } else {
      // 公共部分，建立映射关系
      for (let i = 0; i < part.value.length; i++) {
        ttsToOriginalMap[ttsIndex + i] = originalIndex + i;
      }
      originalIndex += part.value.length;
      ttsIndex += part.value.length;
    }
  });

  // 创建单词高亮显示
  const createHighlightedText = (currentTime: number): string => {
    // 找到当前正在播放的单词范围
    let startIndex = -1;
    let endIndex = -1;

    // 使用缓存的起始位置来提高查找效率
    let searchStartIndex = (createHighlightedText as any).lastSearchIndex || 0;

    // 确保搜索起始位置不会超出words数组范围
    if (searchStartIndex >= words.length) {
      searchStartIndex = 0;
    }

    let found = false;
    // 先从上次搜索位置开始查找
    for (let i = searchStartIndex; i < words.length; i++) {
      const word = words[i];
      // 支持驼峰命名 (startTime/endTime) 和下划线命名 (start_time/end_time)
      const startTime = (word as any).startTime ?? word.start_time;
      const endTime = (word as any).endTime ?? word.end_time;

      // 检查当前时间是否在单词的播放时间范围内
      if (currentTime >= startTime && currentTime <= endTime) {
        // 计算这个单词在TTS文本中的位置
        let wordStart = 0;
        for (let j = 0; j < i; j++) {
          wordStart += words[j].word.length;
        }
        const wordEnd = wordStart + word.word.length;

        // 根据映射找到在原始文本中的位置
        const originalStart =
          wordStart < ttsToOriginalMap.length
            ? ttsToOriginalMap[wordStart]
            : null;
        const originalEnd =
          wordEnd - 1 < ttsToOriginalMap.length
            ? ttsToOriginalMap[wordEnd - 1]
            : null;

        if (originalStart !== null && originalEnd !== null) {
          startIndex = originalStart;
          endIndex = originalEnd + 1;
        }
        // 缓存下次搜索的起始位置
        (createHighlightedText as any).lastSearchIndex = i;
        found = true;
        break;
      }
    }

    // 如果从缓存位置开始没找到，则从头开始查找（防止时间倒退的情况）
    if (!found) {
      for (let i = 0; i < searchStartIndex; i++) {
        const word = words[i];
        // 支持驼峰命名 (startTime/endTime) 和下划线命名 (start_time/end_time)
        const startTime = (word as any).startTime ?? word.start_time;
        const endTime = (word as any).endTime ?? word.end_time;

        // 检查当前时间是否在单词的播放时间范围内
        if (currentTime >= startTime && currentTime <= endTime) {
          // 计算这个单词在TTS文本中的位置
          let wordStart = 0;
          for (let j = 0; j < i; j++) {
            wordStart += words[j].word.length;
          }
          const wordEnd = wordStart + word.word.length;

          // 根据映射找到在原始文本中的位置
          const originalStart =
            wordStart < ttsToOriginalMap.length
              ? ttsToOriginalMap[wordStart]
              : null;
          const originalEnd =
            wordEnd - 1 < ttsToOriginalMap.length
              ? ttsToOriginalMap[wordEnd - 1]
              : null;

          if (originalStart !== null && originalEnd !== null) {
            startIndex = originalStart;
            endIndex = originalEnd + 1;
          }
          // 缓存下次搜索的起始位置
          (createHighlightedText as any).lastSearchIndex = i;
          break;
        }
      }
    }

    // 如果没有找到当前播放的单词，返回原文本
    if (startIndex === -1 || endIndex === -1) {
      return processedText;
    }

    // 只高亮公共部分的字符
    const beforeWord = processedText.substring(0, startIndex);
    const wordText = processedText.substring(startIndex, endIndex);
    const afterWord = processedText.substring(endIndex);

    // 只有当wordText不为空时才应用高亮
    if (wordText.trim().length > 0) {
      return `${beforeWord}<span style="background-color: #fddd00 !important;border-radius: 5px; padding: 0 0px 0px 1.5px;">${wordText}</span>${afterWord}`;
    } else {
      return processedText;
    }
  };

  // ==================== 重构：新的定时器管理 ====================

  let cleanupCalled = false;
  let intervalId: number | null = null;
  let forceStopTimer: number | null = null;

  const UPDATE_INTERVAL = 100; // 100ms更新一次
  const FORCE_STOP_TIMEOUT = 10000; // 10秒强制停止（防止音频卡住导致字幕无限运行）

  // 统一的清理函数
  const cleanup = () => {
    if (cleanupCalled) {
      return;
    }
    cleanupCalled = true;

    // 清理定时器
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }

    if (forceStopTimer !== null) {
      clearTimeout(forceStopTimer);
      forceStopTimer = null;
    }

    // 移除事件监听器
    try {
      if (audio && typeof audio.removeEventListener === 'function') {
        audio.removeEventListener("ended", onAudioEnded);
        audio.removeEventListener("error", onAudioError);
        audio.removeEventListener("pause", onAudioPaused);
        audio.removeEventListener("play", playEventListener);
      }
    } catch (err) {
      // 静默处理错误
    }

    // 清空显示
    setDisplayMsg("");
  };

  // 音频结束事件处理
  const onAudioEnded = () => {
    cleanup();
  };

  // 音频错误事件处理
  const onAudioError = () => {
    cleanup();
  };

  // 音频暂停事件处理
  const onAudioPaused = () => {
    cleanup();
  };

  // 主动检测函数
  const checkAndUpdate = () => {
    if (cleanupCalled) {
      return;
    }

    try {
      // 检查audio对象是否有效
      if (!audio || typeof audio.currentTime !== 'number') {
        cleanup();
        return;
      }

      const currentTime = audio.currentTime;

      // 检查音频是否已结束
      if (audio.ended) {
        cleanup();
        return;
      }

      // 检查音频是否暂停
      if (audio.paused) {
        cleanup();
        return;
      }

      // 更新高亮显示
      const highlightedText = createHighlightedText(currentTime);
      setDisplayMsg(highlightedText);

    } catch (err) {
      cleanup();
    }
  };

  // 启动定时更新
  const startUpdating = () => {
    if (cleanupCalled) {
      return;
    }

    intervalId = window.setInterval(checkAndUpdate, UPDATE_INTERVAL);

    // 设置强制停止定时器，防止音频卡住导致字幕无限运行
    forceStopTimer = window.setTimeout(() => {
      cleanup();
    }, FORCE_STOP_TIMEOUT);
  };

  // 监听音频播放事件
  const playEventListener = () => {
    startUpdating();
  };

  // 注册事件监听器
  audio.addEventListener("ended", onAudioEnded);
  audio.addEventListener("error", onAudioError);
  audio.addEventListener("pause", onAudioPaused);
  audio.addEventListener("play", playEventListener, { once: true });

  // 检查音频是否已在播放
  if (!audio.paused && !audio.ended) {
    startUpdating();
  }

  // 返回清理函数，供外部调用
  return cleanup;
}
